import { validateEmail } from 'src/utils/validateEmail';

/**
 * Simple wrapper function to validate an email and show a toast if there's an error
 * @param email - The email address to validate
 * @returns boolean - true if valid, false if invalid
 */
export const validateEmailAndShowToast = (email: string): boolean => {
  const result = validateEmail(email);
  return result.isValid;
};

/**
 * Validate email without showing toast (useful when you want to handle the error yourself)
 * @param email - The email address to validate
 * @returns validation result object with isValid flag and error message
 */
export const validateEmailSilent = (email: string) => {
  // Use the existing validation without toast
  if (!email || !email.trim().length) {
    return {
      isValid: false,
      errorMessage: "Email can't be empty",
    };
  }

  const trimmedEmail = email.trim().toLowerCase();
  // Basic email format validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(trimmedEmail)) {
    return {
      isValid: false,
      errorMessage: 'Please provide a valid email address format',
    };
  }

  // For silent validation, we'll do basic checks without the toast
  return { isValid: true };
};

export default validateEmailAndShowToast;
